/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductBatteryList } from '../models/PaginatedProductBatteryList';
import type { PatchedProductBattery } from '../models/PatchedProductBattery';
import type { ProductBattery } from '../models/ProductBattery';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsBatteriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductBatteryList
     * @throws ApiError
     */
    public productsBatteriesList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductBatteryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-batteries/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductBattery
     * @throws ApiError
     */
    public productsBatteriesCreate({
        requestBody,
    }: {
        requestBody: ProductBattery,
    }): CancelablePromise<ProductBattery> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-batteries/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductBattery
     * @throws ApiError
     */
    public productsBatteriesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product battery.
         */
        id: number,
    }): CancelablePromise<ProductBattery> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-batteries/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductBattery
     * @throws ApiError
     */
    public productsBatteriesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product battery.
         */
        id: number,
        requestBody: ProductBattery,
    }): CancelablePromise<ProductBattery> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-batteries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductBattery
     * @throws ApiError
     */
    public productsBatteriesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product battery.
         */
        id: number,
        requestBody?: PatchedProductBattery,
    }): CancelablePromise<ProductBattery> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-batteries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsBatteriesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product battery.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-batteries/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
